{
    "ReportingMenu_FirstClosePopup": "Per riaprire il menu, fare clic sul pulsante \"Segnalazioni\" nella barra laterale mentre ci si trova nella pagina Segnali.",
    "NAME": "ReportingMenuLanguage"
}